import axios from 'axios';
import {getBidMode, getStaffId} from '../../scenes/BidSession/helpers.js';
import * as actionTypes from './actionTypes';
import apiCall from '../app/apiCall';
import {buildUrlWithAdminImpersonation} from "../../utilities/helpers";

let commonLabels;
if (sessionStorage.getItem('lng') === 'fr') {
  commonLabels = require('./../../labels/labels.french.json').commonLabels;
} else {
  commonLabels = require('./../../labels/labels.json').commonLabels;
}
export const fetchBidClassesRequest = () => ({
  type: actionTypes.FETCH_BID_PREFERENCE_CLASSES_REQUEST
});
export const fetchBidClassesFailure = message => ({
  type: actionTypes.FETCH_BID_PREFERENCE_CLASSES_FAILURE,
  message
});
export const fetchBidClassesSuccess = bidPreferenceClasses => ({
  type: actionTypes.FETCH_BID_PREFERENCE_CLASSES_SUCCESS,
  bidPreferenceClasses
});
export const fetchBidOptionsAttributesRequest = () => ({
  type: actionTypes.FETCH_BID_OPTIONS_ATTRIBUTES_REQUEST
});
export const fetchBidOptionsAttributesSuccess = classOptionAttributes => ({
  type: actionTypes.FETCH_BID_OPTIONS_ATTRIBUTES_SUCCESS,
  classOptionAttributes
});
export const fetchBidOptionsAttributesFailure = response => ({
  type: actionTypes.FETCH_BID_OPTIONS_ATTRIBUTES_FAILURE,
  response
});
export const fetchpairingdate = pairingdate => ({
  type: actionTypes.FETCH_PAIRING_DATE_SUCCESS,
  pairingdate
});

export const savePreference = (
  bidSession,
  classOption,
  parameterValues,
  editPreference,
  wish,
  maxnn,
  OptionPropertyId = 0,
  adminComments,
  adminName,
  weight,
  bidmode = getBidMode()
) => {
  const preferenceOptionPropertyId = OptionPropertyId;
  const scores = bidSession.bidPreferences.totalEntries + 1;
  let bidPreference;

  const bidMode = getBidMode();
  if (
    bidSession.bidMode === commonLabels.MANUAL ||
    bidSession.bidMode === commonLabels.LADDER
  ) {
    let weights;
    if (bidMode === commonLabels.AUTOMATIC) {
      weights = weight !== undefined ? weight : 2;
    } else if (bidMode === commonLabels.LADDER) {
      weights = weight !== undefined ? weight : 1;
    } else {
      weights = weight !== undefined ? weight : 50;
    }
    if (Object.keys(editPreference).length > 0) {
      bidPreference = {
        ...editPreference,
        parameterValues,
        wish,
        maxnn,
        adminComments,
        adminName,
        score: weights,
        bidMode: bidMode
      };
    } else {
      bidPreference = {
        bidSessionId: bidSession.currentBid.bidSessionId,
        staffId: getStaffId(),
        preferenceOptionId: classOption,
        preferenceOptionPropertyId,
        score: weights,
        parameterValues,
        wish,
        maxnn,
        adminComments,
        adminName,
        bidMode: bidMode
      };
    }
  } else if (Object.keys(editPreference).length > 0) {
    bidPreference = {
      ...editPreference,
      parameterValues,
      wish,
      maxnn,
      adminComments,
      adminName,
      bidMode: bidMode
    };
  } else {
    bidPreference = {
      bidSessionId: bidSession.currentBid.bidSessionId,
      staffId: getStaffId(),
      preferenceOptionId: classOption,
      preferenceOptionPropertyId,
      score: scores,
      parameterValues,
      wish,
      maxnn,
      adminComments,
      adminName,
      bidMode: bidMode
    };
  }
  fetch(buildUrlWithAdminImpersonation('api/preferences/save'), {
    method: 'POST',
    body: JSON.stringify({
      bidPreference
    })
  });
};

export function deletePreference(
  bidId,
  employeeBidId,
  adminComments,
  adminName
) {
  return () => {
    const deletepreferenceUrl = buildUrlWithAdminImpersonation(`preferences/delete/?employeebid_id=${employeeBidId}&bidaggregate_id=${bidId}&admin_Comments=${adminComments}&admin_Name=${adminName}`);
    return apiCall(deletepreferenceUrl, 'delete');
  };
}

export const fetchClassOptionAttributes = (optionClassId, bidSessionId) => {
  return dispatch => {
    dispatch(fetchBidOptionsAttributesRequest());
    const staffId = getStaffId();
    fetch(
      `api/preferences/options/${optionClassId}/bidsession_id/${bidSessionId}/staffId/${staffId}`
    )
      .then(res => res.json())
      .then(json => {
        return dispatch(
          fetchBidOptionsAttributesSuccess(json.classOptionAttribute)
        );
      });
  };
};

export const fetchBidPreferenceClasses = () => {
  return dispatch => {
    dispatch(fetchBidClassesRequest());
    fetch('api/preference/classes')
      .then(res => res.json())
      .then(json => {
        const preferenceClasses = json;

        fetch('api/preferences/options')
          .then(res => res.json())
          .then(json => {
            const preferenceOptions = json;

            preferenceClasses.entries.map(
              preferenceClass =>
                (preferenceClass.options = preferenceOptions.entries.filter(
                  option =>
                    option.preferenceClassId ===
                    preferenceClass.preferenceClassId
                ))
            );
            return dispatch(
              fetchBidClassesSuccess({
                preferenceClasses,
                preferenceOptions,
                dialogNextState: true
              })
            );
          });
      });
  };
};

export function fetchdate(pairingName, staffId, bidStart, bidOptionId) {
  return dispatch => {
    const dateUrl = `preferences/bid-sessions/pairing/active-dates/?pairingName=${pairingName}&staffId=${staffId}&bidOptionId=${bidOptionId}`;
    apiCall(dateUrl, 'get').then(response => {
      const datearray = [];
      const data = response.data;
      data.forEach(arrayItem => {
        const x = arrayItem.activityStartDate[1];
        if (x === bidStart) {
          datearray.push(arrayItem.activityStartDate[2]);
        }
      });
      dispatch(fetchpairingdate(datearray));
    });
  };
}
